import login_bg from 'static/images/login/login_bg.jpg';

import mainInfoIconCommonBlue from 'static/images/icon/mainInfo_Icon_common_blue.gif';
import mainInfoIconCommonWarning from 'static/images/icon/mainInfo_Icon_common_warning.gif';
import mainInfoIconCommonDanger from 'static/images/icon/mainInfo_Icon_common_danger.gif';
import mainInfoIconCommonNone from 'static/images/icon/mainInfo_Icon_common_none.gif';

import mainInfoIconBlue from 'static/images/icon/mainInfo_Icon_blue.gif';
import mainInfoIconWarning from 'static/images/icon/mainInfo_Icon_warning.gif';
import mainInfoIconDanger from 'static/images/icon/mainInfo_Icon_danger.gif';
import mainInfoIconNone from 'static/images/icon/mainInfo_Icon_none.gif';

export const theme = {
  common: {
    mainMapBg: `url(${login_bg});`,
    mainInfoBg: `#0b102e`,
    scrollTrackBg: '#60687d',
    scrollThumbBg: '#0a1e41',
    headerBg: '#111a33',
    clockFlex: '1.1',
    clockBg: '#12162f',
    clockPadding: '12px 6%',
    clockColor: '#5ba5bd',
    clockWdith: '270px',
    clockFont: '15px',
    headerButtonColor: '#60687d',
    titleWidth: '40%',
    titleBoxColor:
      'rgb(17, 25, 51) 46px 0px 32px -21px inset, rgb(17, 25, 51) -46px 0px 32px -21px inset, rgb(102, 191, 239) 0px -30px 22px -32px inset, rgb(102, 191, 239) 0px -9px 0px -8px inset;',
    titleColor: '#d0d5e0',
    titleFontSize: '21px',
    titleStroke: '0px #d0d5e0',
    footerBg: '#101010',
    footerBtnColor: '#60687d',
    footerSelectBtnColor: '#fff',
    mainSubBg: '#101010',
    sideEventBg: '#131b3a',
    legendBg: '#d0d5e0',

    mainInfoModuleDetailBoxBg: 'rgba(199, 229, 241, 0.1)',
    mainInfoIconBlue: `url(${mainInfoIconCommonBlue});`,
    mainInfoIconWarning: `url(${mainInfoIconCommonWarning});`,
    mainInfoIconDanger: `url(${mainInfoIconCommonDanger});`,
    mainInfoIconNone: `url(${mainInfoIconCommonNone});`,
  },
  rotec: {
    mainMapBg: `#cbdbe9`,
    mainInfoBg: `#cbdbe9`,
    scrollTrackBg: '#727272',
    scrollThumbBg: '#2b2b2b',
    headerBg: '#dde0ea',
    clockFlex: '2',
    clockBg: '#2f2b43',
    clockPadding: '8px 8%',
    clockColor: '#fff',
    clockWdith: '350px',
    clockFont: '20px',
    headerButtonColor: '#838383',
    titleWidth: '80%',
    titleBoxColor: '#2f2b43 0px -30px 22px -32px inset, #2f2b43 0px -9px 0px -8px inset;',
    titleColor: '#2f2b43',
    titleFontSize: '45px',
    titleStroke: '2px #2f2b43',
    footerBg: '#e2e2e2',
    footerBtnColor: '#60687d',
    footerSelectBtnColor: '#000',
    mainSubBg: '#e2e2e2',
    sideEventBg: '#5b2f2f',
    legendBg: '#99aadb',

    mainInfoModuleDetailBoxBg: '#424242',
    mainInfoIconBlue: `url(${mainInfoIconBlue});`,
    mainInfoIconWarning: `url(${mainInfoIconWarning});`,
    mainInfoIconDanger: `url(${mainInfoIconDanger});`,
    mainInfoIconNone: `url(${mainInfoIconNone});`,
  },
};
